export default class CronService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('crons', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('crons/' + id, params)
	}

	runCron(id) {
		return this.apiService.callPost('crons/' + id + '/run')
	}

	unlockCron(id) {
		return this.apiService.callPost('crons/' + id + '/unlock')
	}

	updateEntity(id, params) {
		return this.apiService.callPut('crons/' + id, params)
	}

	getCronRuns(id, params) {
		return this.apiService.callGet('crons/' + id + '/runs', params)
	}

	getCronRun(id, params) {
		return this.apiService.callGet('crons/runs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/CronService.js